import React from 'react';
import PropTypes from 'prop-types';
import { Button, SelectControl } from '@si-armes/dsfr-react';

const Pagination = ({
    currentPage,
    goToPreviousPage,
    goToNextPage,
    limitPerPage,
    onChangePagination,
    optionsPaginations,
    desactiverPaginationSuivante,
}) => {
    return (
        <div
            style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                justifyContent: 'flex-end',
            }}
        >
            <Button
                size="md"
                variant="secondary"
                icon="fr-icon-arrow-left-s-line"
                className="margin-top-xs"
                type="button"
                onClick={goToPreviousPage}
                disabled={currentPage === 1}
            />

            <Button className="margin-top-xs no-cursor-pointer" variant="primary">
                {currentPage}
            </Button>

            <Button
                size="md"
                variant="secondary"
                icon="fr-icon-arrow-right-s-line"
                className="margin-top-xs"
                type="button"
                disabled={desactiverPaginationSuivante}
                onClick={goToNextPage}
            />

            <div className="btn-group-align-right">
                <SelectControl
                    name="resulatParPage"
                    className="fr-btn"
                    onChange={(event) => onChangePagination(event.target.value)}
                    options={optionsPaginations}
                    value={limitPerPage}
                />
            </div>
        </div>
    );
};

Pagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    goToPreviousPage: PropTypes.func.isRequired,
    goToNextPage: PropTypes.func.isRequired,
    limitPerPage: PropTypes.number.isRequired,
    onChangePagination: PropTypes.func.isRequired,
    optionsPaginations: PropTypes.array.isRequired,
    desactiverPaginationSuivante: PropTypes.bool,
};

export default Pagination;
